import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { AuthService } from '../../../../../../auth/auth.service';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-tickets-grs-filter-new',
  templateUrl: './tickets-grs-filter.component.html',
  styleUrls: ['./tickets-grs-filter.component.scss'],
  standalone: false,
})
export class TicketsGRSFilterComponent {
  @Input() ticketsPeriodFilter;
  @Input() ticketsCurrentFilter;
  @Input() brigadeAssign;
  @Input() ticketsMultipleAssign;
  @Input() tickets;

  constructor(private authService: AuthService) {}

  public ticketsListRefresh(): void {
    this.ticketsMultipleAssign.ticketsListRefresh();
  }

  public onResetCheckedTickets(): void {
    this.ticketsMultipleAssign.onResetCheckedTickets();
  }

  public onChangeTicketType(type): void {
    this.ticketsCurrentFilter.changeTypeSelected(type);
  }

  public assignBrigades(): void {
    this.brigadeAssign.assignBrigades();
  }

  public onChangeMode(mode): void {
    this.ticketsCurrentFilter.onChangeMode(mode);
  }

  public isChecked(typeGP): boolean {
    return typeGP.selected;
  }

  public handleChange(typeGP, event): void {
    typeGP.selected = event.target.checked;
    this.ticketsCurrentFilter.resetTicketStatus();
    this.ticketsCurrentFilter.recalculateStatusAndTickets();
  }

  public onChangeSubtypeGPs(subtypeGP): void {
    this.ticketsPeriodFilter.appliedSubtypeGPSelected = subtypeGP;
    this.ticketsCurrentFilter.resetTicketStatus();
    this.ticketsCurrentFilter.recalculateStatusAndTickets();
  }

  public isGRSUser() {
    return this.authService.isGRSUser();
  }
}
